module.exports = __webpack_public_path__ + "assets/img/iDi_logo_extended_white.63582192.svg";